// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S860","toggleWrap":"styles_toggleWrap__1lS2W","content":"styles_content__10bbL","selectAreaCode":"styles_selectAreaCode__3hhLA"};